import { type ReactNode, useId } from 'react';

import { classlist } from '~/_shared/design-system/lib/classlist';
import {
	BaseButton,
	type BaseButtonProps,
} from '~/_shared/design-system/ui/atoms/button/base/base-button';

import './icon-button.css';

interface IconButtonProps extends Omit<BaseButtonProps, 'children' | 'size'> {
	children: ReactNode;
	// Required at the type level so a missing label is caught at compile time.
	'aria-label': string;
}

const IconButton = ({ children, className, id, ...rest }: IconButtonProps) => {
	// Instance-unique default id (explicit `id` prop wins) — see BaseButton.
	const auto_id = useId();
	return (
		<BaseButton
			{...rest}
			id={id ?? `IconButton-${auto_id}`}
			size='icon'
			className={classlist('icon-button', className)}
		>
			{children}
		</BaseButton>
	);
};

export type { IconButtonProps };
export { IconButton };
